import { state } from './state';

export const Auth = (() => {
    const obj = {};

    const { get, set, reset } = state('auth', {
        refreshToken: null,
        accessToken: null,
        user: null
    });

    obj.setAccessToken = (token) => {
        set((current) => ({
            ...current,
            accessToken: token
        }));
    };

    obj.setRefreshToken = (token) => {
        set((current) => ({
            ...current,
            refreshToken: token
        }));
    };

    obj.setUser = (user) => {
        set((current) => ({
            ...current,
            user: user
        }));
    };

    obj.getAccessToken = () => {
        return get().accessToken;
    };

    obj.getRefreshToken = () => {
        return get().refreshToken;
    };

    obj.getUser = () => {
        return get().user;
    };

    obj.clear = () => {
        reset();
    };

    return obj;
})();
